import { Dialog } from '#src/components/dialog/index.tsx';

import { JonumKycPromptView } from './JonumKycPromptView.tsx';

type Props = {
  open: boolean;
  onDone: () => void;
};

export const JonumKycPromptDialog = ({ open, onDone }: Props) => {
  return (
    <Dialog
      open={open}
      onClose={onDone}
      hideHeader
      maxWidth="xs"
      fullWidth
      disableBackdropClick
      disableEscapeKeyDown
    >
      <JonumKycPromptView onDone={onDone} />
    </Dialog>
  );
};
